import { db } from './firebase';

import {
  addDoc,
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import { Account } from '../sp-types/accountTypes';
import { updateUserAccount } from './userFB';

export async function createAccount(data: Account) {
  try {
    console.log(data);
    const docRef = await addDoc(collection(db, 'accounts'), data);
    console.log('Document written with ID: ', docRef.id);
    updateUserAccount(data.creator, docRef.id);
    console.log('Document Written Successfully');
    return docRef.id;
  } catch (err) {
    console.log(`error found! ${err}`);
  }
}

export async function createAccountWithId(data: Account, customAccountId: string) {
  try {
    const docRef = doc(db, 'accounts', customAccountId);
    await setDoc(docRef, data);
    console.log('Document written with ID: ', docRef.id);
    updateUserAccount(data.creator, docRef.id);
    console.log('Document Written Successfully');
    return docRef.id;
  } catch (err) {
    console.log(`error found! ${err}`);
  }
}

export async function getAccount(id: string): Promise<[Account, string] | null> {
  const docRef = doc(db, 'accounts', id);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    const account = docSnap.data();
    account.id = docSnap.id;
    return [account as Account, docSnap.id];
  } else {
    // No matching documents found
    console.log('No matching documents found.');
    return null;
  }
}

export async function getAccounts(): Promise<Account[] | null> {
  const accountsCol = collection(db, 'accounts');
  const accountsSnapshot = await getDocs(accountsCol);

  const accountList = accountsSnapshot.docs.map((item) => ({ id: item.id, ...(item.data() as Account) }));

  return accountList;
}

export async function updateAccountProperty(accountId: string, propertyName: keyof Account, propertyValue: any) {
  try {
    const docRef = doc(db, 'accounts', accountId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const updatedData = { ...docSnap.data(), [propertyName]: propertyValue };
      await updateDoc(docRef, updatedData);
      console.log(`Order property '${propertyName}' updated successfully.`);
    } else {
      console.log(`Order with ID '${accountId}' does not exist.`);
    }
  } catch (err) {
    console.error(`Error updating order property: ${err}`);
  }
}

export async function updateAccount(accountId: string, updatedAccountData: Account) {
  try {
    console.log(updatedAccountData);
    const docRef = doc(db, 'accounts', accountId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const updatedData = updatedAccountData;
      await updateDoc(docRef, updatedData as any);
      console.log(`Account ' updated successfully.`);
    } else {
      console.log(`Order with ID '${accountId}' does not exist.`);
    }
  } catch (err) {
    console.error(`Error updating order property: ${err}`);
  }
}

// Add user to an account
export const addUserToAccount = async (accountId: string, userId: string) => {
  const accountRef = doc(db, 'accounts', accountId);

  await updateDoc(accountRef, {
    users: arrayUnion(userId),
  });
  console.log('User added to account:', accountId);
};

// Check if user is part of an account
export const isUserInAccount = (account: Account, userId: string): boolean => {
  return !!account?.users?.[userId];
};

export async function updateAccountCollateral(id: string, amount: number, operation: string, docpath?: string) {
  try {
    let availableCollateral;
    let allocatedCollateral;
    let immediateConfirmation;
    let collateral;
    const docRef = doc(db, 'accounts', id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      collateral = docSnap.data().collateral;
      availableCollateral = collateral.availableCollateral;
      allocatedCollateral = collateral.allocatedCollateral;
      immediateConfirmation = collateral.immediateConfirmation;
    } else {
      // No matching documents found
      console.log('No matching documents found.');
      return;
    }
    switch (operation) {
      case 'deposit':
        console.log(collateral);
        collateral.availableCollateral = availableCollateral + amount;
        collateral.newCollateralAmount = 0;
        await updateDoc(doc(db, 'accounts', id), { collateral: collateral });
        break;
      case 'withdraw':
        if (amount <= availableCollateral) {
          collateral.availableCollateral = amount < availableCollateral ? availableCollateral - amount : 0;
          collateral.allocatedCollateral =
            amount < availableCollateral ? allocatedCollateral + amount : allocatedCollateral + availableCollateral;
          await updateDoc(doc(db, 'accounts', id), { collateral: collateral });
        }
        break;
      case 'immediate':
        collateral.immediateConfirmation = immediateConfirmation - amount;
        collateral.marginCall = amount;
        await updateDoc(doc(db, 'accounts', id), { collateral: collateral });
        break;
      case 'uploadConfirmationDoc':
        collateral.confirmationDoc = arrayUnion(docpath);
        await updateDoc(doc(db, 'accounts', id), { collateral: collateral });
        break;
      case 'removeConfirmationDoc':
        collateral.confirmationDoc = arrayRemove(docpath);
        await updateDoc(doc(db, 'accounts', id), { collateral: collateral });
        break;
    }
    console.log('Account been set successfully');
  } catch (err) {
    console.log(`error found! ${err}`);
  }
}
